export default __webpack_public_path__ + "static/media/whatsappIcon.717e0505.svg";